import urlJoin from 'url-join';
import stipulate, {resolveUrl} from 'stipulate';

import {baseUrl, baseOptions} from './base';

export const domainAvailability = function(options, query) {
  options || (options = {});

  if (!options.domain) {
    throw new Error('Expected options.domain to be set');
  }

  let url = urlJoin(baseUrl, 'pb/domains', options.domain, 'availability');
  url = resolveUrl(url, query);

  return stipulate(url, baseOptions);
};

export const domainsList = function(options, query) {
  let url = urlJoin(baseUrl, 'pb/domains/');
  url = resolveUrl(url, query);

  return stipulate(url, baseOptions);
};

export default {
  domainAvailability,
  domainsList
};
